<template>
  <v-row align="center" justify="center">

    <!-- Vídeo vertical -->
    <v-col cols="12" md="5" class="d-flex justify-center">
      <div class="video-shell">
        <iframe
          src="https://www.youtube-nocookie.com/embed/1hXHSqC6Z8I"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
          title="Cardápio Digital"
          class="video-frame"
        />
      </div>
    </v-col>

    <!-- Conteúdo -->
    <v-col cols="12" md="7">
      <SectionTitle>Veja como é o Cardápio Digital</SectionTitle>

      <p class="section-desc mt-4">
        Seu cliente acessa o cardápio direto no celular, faz o pedido e você recebe tudo organizado — sem erro, sem confusão.
      </p>

      <div class="feature-list mt-7">
        <div v-for="(item, i) in features" :key="i" class="feature-item">
          <div class="feature-icon-wrap">
            <v-icon size="22" color="error">{{ item.icon }}</v-icon>
          </div>
          <div>
            <p class="feature-title">{{ item.title }}</p>
            <p class="feature-desc">{{ item.desc }}</p>
          </div>
        </div>
      </div>
    </v-col>

  </v-row>
</template>

<script>
import SectionTitle from "@/components/SectionTitle.vue";

export default {
  name: 'CardapioDigitalVideo',
  components: { SectionTitle },

  data: () => ({
    features: [
      {
        icon: 'mdi-cart-plus',
        title: 'Venda complementar automática',
        desc: 'O cardápio sugere produtos complementares no momento do pedido, aumentando o ticket médio sem esforço.',
      },
      {
        icon: 'mdi-qrcode-scan',
        title: 'Acesso sem cadastro e sem app',
        desc: 'O cliente abre pelo link ou QR Code direto no celular — sem baixar nada, sem criar conta.',
      },
      {
        icon: 'mdi-whatsapp',
        title: 'Acompanhamento em tempo real',
        desc: 'O cliente acompanha o status do pedido pelo próprio cardápio e recebe avisos automáticos pelo WhatsApp.',
      },
    ],
  }),
};
</script>

<style scoped lang="scss">
  /* Container do vídeo com sombra e borda */
  .video-shell {
    position: relative;
    border-radius: 24px;
    overflow: hidden;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.35);
    width: 100%;
    max-width: 300px;

    @media (max-width: 600px) {
      max-width: 240px;
    }
  }

  .video-frame {
    display: block;
    width: 100%;
    aspect-ratio: 9 / 16;
    border: none;
  }

  /* Texto descritivo */
  .section-desc {
    font-size: 16px;
    line-height: 1.7;
    color: var(--text-secondary);
    margin: 0;
    max-width: 480px;
  }

  /* Lista de features */
  .feature-list {
    display: flex;
    flex-direction: column;
    gap: 22px;
  }

  .feature-item {
    display: flex;
    align-items: flex-start;
    gap: 16px;
  }

  .feature-icon-wrap {
    flex-shrink: 0;
    width: 44px;
    height: 44px;
    border-radius: 12px;
    background: rgba(244, 6, 18, 0.1);
    border: 1px solid rgba(244, 6, 18, 0.2);
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .feature-title {
    font-size: 15px;
    font-weight: 700;
    margin: 0 0 4px;
    color: var(--text-primary);
  }

  .feature-desc {
    font-size: 14px;
    line-height: 1.55;
    color: var(--text-muted);
    margin: 0;
  }
</style>
